import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntityMainService {

constructor(private http:HttpClient) { }

GetDataEntity(Token:String):Observable<any>{
  return this.http.get(environment.BaseUrl + "Daro/DataEntityMain?token="+Token).pipe(
    map(data=>{
      return data as any
    })
  )
}

uploadFile(body){

  const headers = new HttpHeaders().set('content-type', 'application/json');
  return this.http.post(environment.BaseUrl + "Daro/DataEntityMain/Upload?",body).pipe(
    map(data=>{

      return data
    })
  )
}

SubmitDateOfIssue(id:number,Token:String,date:String):Observable<any>{

    return this.http.get(environment.BaseUrl + "Daro/DataEntityMain/SubmitDateOfIssue?id="+id+"&Token="+Token+"&date="+date).pipe(
      map(data=>{
        return data as any
      })
    )

}


}
